import {__platform_browser_private__ as _} from '@angular/platform-browser';

export type DomAdapter = typeof _.DomAdapter;
export var DomAdapter: typeof _.DomAdapter = _.DomAdapter;
export var setRootDomAdapter: typeof _.setRootDomAdapter = _.setRootDomAdapter;
export var getDOM: typeof _.getDOM = _.getDOM;
export type DomRootRenderer = typeof _.DomRootRenderer;
export var DomRootRenderer: typeof _.DomRootRenderer = _.DomRootRenderer;
export type DomRootRenderer_ = typeof _.DomRootRenderer_;
export var DomRootRenderer_: typeof _.DomRootRenderer_ = _.DomRootRenderer_;
export type DomSharedStylesHost = typeof _.DomSharedStylesHost;
export var DomSharedStylesHost: typeof _.DomSharedStylesHost = _.DomSharedStylesHost;
export type SharedStylesHost = typeof _.SharedStylesHost;
export var SharedStylesHost: typeof _.SharedStylesHost = _.SharedStylesHost;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
